import React from 'react';
import {Card, FlexBox} from 'components';
import {DataFormV1} from 'schema';
import {DataFormCompareLayout} from 'schema/form/components/DataFormCompareLayout';
import type {CompareEntitiesFormsProps} from '../types';
import {useCompareEntitiesContext} from '../context/CompareEntitiesContext';

export const CompareEntitiesForms: React.FC<CompareEntitiesFormsProps> = ({
  formConfiguration,
  targetHeader,
  sourceHeader,
}) => {
  const {target, source, onChange} = useCompareEntitiesContext();

  return (
    <FlexBox horizontal flex={1}>
      <DataFormCompareLayout
        renderCurrent={() => (
          <Card mode={'light'} color={'primary'}>
            {targetHeader}
            <DataFormV1
              id={'targetDataForm'}
              schema={target.schema}
              originalData={target.data}
              data={target.data ?? {}}
              configuration={formConfiguration}
              mode="edit"
              relatedData={{}}
              showErrors={true}
              onDataChanged={onChange}
            />
          </Card>
        )}
        renderProposed={() =>
          source?.schema ? (
            <Card mode={'light'} color={'primary'}>
              {sourceHeader}
              <DataFormV1
                id={'sourceDataForm'}
                schema={source?.schema}
                data={source?.data ?? {}}
                configuration={formConfiguration}
                mode="read-only"
                relatedData={{}}
              />
            </Card>
          ) : (
            <Card>Ingen forskjeller</Card>
          )
        }
      />
    </FlexBox>
  );
};
